import getNotificationBarHostId from '../utils/getNotificationBarHostId';
import { orchestrator } from 'satcheljs';
import {
    showNotification,
    showNotificationWithButtonCallback,
} from '../actions/notificationBarActions';
import {
    lazyShowNotificationWithButtonCallback,
    lazyShowNotification,
} from 'owa-notification-bar-force-dismiss';

orchestrator(showNotificationWithButtonCallback, actionMessage => {
    const { actionSource } = actionMessage;

    const hostId = getNotificationBarHostId(actionSource);

    lazyShowNotificationWithButtonCallback.import().then(func => {
        const props = {
            notificationBarHostId: hostId,
            ...actionMessage,
        };

        func(
            props.actionName,
            props.notificationBarHostId,
            props.messageString,
            props.primaryActionText,
            props.primaryActionClickedCallback,
            props.icon,
            props.primaryActionHotKeyCommand
        );
    });
});

orchestrator(showNotification, actionMessage => {
    const { actionSource } = actionMessage;

    const hostId = getNotificationBarHostId(actionSource);

    lazyShowNotification.import().then(func => {
        const props = {
            notificationBarHostId: hostId,
            ...actionMessage,
        };

        func(
            props.actionName,
            props.notificationBarHostId,
            props.messageString,
            props.notificationOptions,
            props.actionButtonOptions
        );
    });
});
